const data = [
    { id: 1, name: "PRATA" },
    { id: 2, name: "CINZA" },
    { id: 3, name: "BRANCO" },
    { id: 4, name: "PRETO" },
    { id: 5, name: "AZUL" },
];

export default [...data];
